import { Tariff } from '@/lib/types/tariff';
import { OneTimePurchaseTariff, SubscriptionTariffWithLTV } from '@addmile/backend-client';

export const normalizeTariffs = (
  tariff: OneTimePurchaseTariff | SubscriptionTariffWithLTV,
): Tariff => ({
  id: tariff.id,
  externalId: tariff.externalId,
  name: tariff.name,
  description: tariff.description,
  regularPrice: 'price' in tariff ? tariff.price : (tariff.regular?.price ?? ''),
  ltvs: 'ltvs' in tariff ? (tariff.ltvs ?? []) : [],
  currency: tariff.currency,
  provider: tariff.provider,
});
